import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyImplants from './components/WhyImplants';
import DrYasir from './components/DrYasir';
import ImplantTypes from './components/ImplantTypes';
import AdvancedFeatures from './components/AdvancedFeatures';
import NervousPatients from './components/NervousPatients';
import WhichApplies from './components/WhichApplies';
import Gallery from './components/Gallery';
import EasyToReach from './components/EasyToReach';
import Testimonials from './components/Testimonials';
import CostFinance from './components/CostFinance';
import BookingForm from './components/BookingForm';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <WhyImplants />
      <DrYasir />
      <ImplantTypes />
      <AdvancedFeatures />
      <NervousPatients />
      <WhichApplies />
      <Gallery />
      <EasyToReach />
      <Testimonials />
      <CostFinance />
      <BookingForm />
      <Contact />
      <Footer />
    </div>
  );
}
